import { Eye, EyeOff, Settings2 } from 'lucide-react'

// Extraído literalmente de ChartPage.jsx (antes definido inline en ese
// archivo) para que ChartPublicPage.jsx pueda mostrar la misma UI de
// indicadores del registro sin reimplementarla. Puramente presentacional.
export default function IndicatorToggle({ active, onChange, color, label, onSettings }) {
  return (
    <div className="flex items-center group">
      {/* Label / name area — solo toggle */}
      <button
        onClick={() => onChange(!active)}
        className="flex-1 flex items-center gap-2.5 px-3 py-2.5 min-h-[44px] hover:bg-slate-50 dark:hover:bg-gray-700/60 transition-colors text-left"
      >
        <div className="w-4 h-1 rounded-full flex-shrink-0" style={{ backgroundColor: active ? color : '#64748b' }} />
        <span className={`text-sm flex-1 ${active ? 'text-slate-800 dark:text-gray-100' : 'text-slate-400 dark:text-gray-500'}`}>
          {label}
        </span>
      </button>

      {/* Settings icon */}
      {onSettings && (
        <button
          onClick={onSettings}
          className="flex-shrink-0 px-2.5 py-2.5 min-h-[44px] flex items-center text-slate-400 dark:text-gray-500 hover:text-slate-700 dark:hover:text-gray-200 hover:bg-slate-100 dark:hover:bg-gray-700 transition-colors"
          title="Configurar"
        >
          <Settings2 size={13} />
        </button>
      )}

      {/* Toggle visibility icon */}
      <button
        onClick={() => onChange(!active)}
        className="px-3 py-2.5 min-h-[44px] flex items-center hover:bg-slate-50 dark:hover:bg-gray-700/60 transition-colors"
        title={active ? 'Ocultar' : 'Mostrar'}
      >
        {active
          ? <Eye size={12} className="text-slate-400 dark:text-gray-500 flex-shrink-0" />
          : <EyeOff size={12} className="text-slate-300 dark:text-gray-700 flex-shrink-0" />}
      </button>
    </div>
  )
}
